import React, { useEffect, useRef } from "react";
import { TCText } from "../../components/TCText/TCText";
import { Strings } from "../../utils/strings";
import { Colors } from "../../utils/colors";
import { StaticBackdropModal } from "../../components/modal/staticBackdropModal/StaticBackdropModal";
import { observer } from "mobx-react-lite";
import { useLoginStore } from "../../stores/StoreContext";
import { Button } from "../../components/button/Button";
import { OverlayLoadingIndicator } from "../../components/overlayLoadingIndicator/OverlayLoadingIndicator";
import { useNavigate } from "react-router-dom";
import { isIOS } from "react-device-detect";

type props = {};

export const Login: React.FC<props> = observer(() => {
  const loginStore = useLoginStore();
  const inputRef = useRef<HTMLInputElement>(null); // Create a ref for the input element
  const navigate = useNavigate();

  useEffect(() => {
    loginStore.navigate = navigate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "450px",
        width: "90%",
        height: "100vh",
        marginLeft: "auto",
        marginRight: "auto",
        overflow: "hidden", // Disable scrolling
        marginTop: isIOS ? -50 : -30,
      }}>
      <TCText
        style={{ fontWeight: 600, fontSize: 25, color: "black" }}
        value={Strings.LOGIN}
      />
      <TCText
        style={{
          fontWeight: 400,
          fontSize: 16,
          color: Colors.grey,
          marginTop: 10,
        }}
        value="Please verify your email address"
      />
      <div style={{ width: "100%", marginTop: 50 }}>
        <TCText
          style={{
            fontSize: 15,
            color: Colors.grey,
            marginBottom: 5,
            fontWeight: 400,
            marginLeft: 2,
          }}
          value={Strings.EMAIL_ADDRESS}
        />
        <input
          type="email"
          value={loginStore.email}
          onChange={loginStore.handleEmailChange}
          onKeyDown={loginStore.handleKeyPress}
          ref={inputRef}
          required
          style={{
            width: "100%",
            padding: isIOS ? "18px 16px" : "15px 16px",
            borderRadius: 17,
            border: `1px solid ${
              !loginStore.isValid ? "red" : Colors.lightGreyBackground
            }`,
            backgroundColor: "white",
            fontSize: isIOS ? 16 : 14,
            outline: "none",
            // iOS specific styling to prevent zoom
          }}
          // iOS specific attribute to prevent zoom
          autoComplete={isIOS ? "off" : "on"}
          placeholder="Enter your email address"
        />
        <Button
          text={Strings.LOGIN}
          onPress={() => {
            loginStore.sendOTPCode();
          }}
          disabled={loginStore.isLoading}
          btnStyle={{
            width: "100%",
            backgroundColor: Colors.darkBrown,
            marginTop: 40,
            height: 52,
          }}
          textStyle={{ color: "white" }}
        />
      </div>
      <StaticBackdropModal
        children={loginStore.modalData?.children}
        title={loginStore.modalData?.title}
        handleClose={
          loginStore.modalData?.onClose ??
          (() => (loginStore.modalData = undefined))
        }
        show={!!loginStore.modalData}
        headerIcon={loginStore.modalData?.headerIcon}
        btnText={loginStore.modalData?.btnText}
        handleOpen={loginStore.modalData?.onAccept}
      />
      <OverlayLoadingIndicator
        loading={loginStore.isLoading}
        text="Sending OTP..."
      />
    </div>
  );
});
